import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router";

import { useAuth } from "./use-auth";

/**
 * 未認証なら IdP へフルページ遷移させるルートガード。
 *
 * 認可（権限がない）はここの責務にしない。ルート単位で permissions-check ベースの
 * 判定を被せる（useCan）。
 */
export function ProtectedRoute() {
  const { status, login } = useAuth();
  const location = useLocation();
  // 再レンダで login が二重に走るとリダイレクトループになるため 1 回に固定する
  const hasStartedLogin = useRef(false);

  const currentPath = `${location.pathname}${location.search}`;

  useEffect(() => {
    if (status !== "unauthenticated" || hasStartedLogin.current) return;

    hasStartedLogin.current = true;
    login({
      returnTo: new URL(currentPath, window.location.origin).href,
    });
  }, [status, login, currentPath]);

  if (status !== "authenticated") return <FullPageSpinner />;

  return <Outlet />;
}

function FullPageSpinner() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen items-center justify-center"
    >
      <span className="border-muted-foreground/30 border-t-foreground size-6 animate-spin rounded-full border-2" />
      <span className="sr-only">読み込み中</span>
    </div>
  );
}
